const getJobPrice = job =>
  job.maxPrice
    ? `Up to £ ${job.maxPrice}`
    : job.averagePrice
    ? `About £ ${job.averagePrice}`
    : `Contract price`

export default getJobPrice
